/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AuthRequestAdminCredentialsDto } from '../../models/auth-request-admin-credentials-dto';
import { AuthResponseAdminLoginDto } from '../../models/auth-response-admin-login-dto';

export interface AdminAuthControllerLoginV1$Params {
      body: AuthRequestAdminCredentialsDto
}

export function adminAuthControllerLoginV1(http: HttpClient, rootUrl: string, params: AdminAuthControllerLoginV1$Params, context?: HttpContext): Observable<StrictHttpResponse<AuthResponseAdminLoginDto>> {
  const rb = new RequestBuilder(rootUrl, adminAuthControllerLoginV1.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AuthResponseAdminLoginDto>;
    })
  );
}

adminAuthControllerLoginV1.PATH = '/v1/admin/auth/login';
